define(["exports", "./utils", "../core/l10n", "hyperhtml"], function (_exports, _utils, _l10n, _hyperhtml) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject7() {
    const data = _taggedTemplateLiteral(["<p role='navigation' id='back-to-top'><a href='#title'><abbr title='Back to Top'>&uarr;</abbr></a></p>"]);

    _templateObject7 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6() {
    const data = _taggedTemplateLiteral(["<h2 class=\"introductory\">", "</h2>"]);

    _templateObject6 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5() {
    const data = _taggedTemplateLiteral(["<nav id=\"toc\">"]);

    _templateObject5 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4() {
    const data = _taggedTemplateLiteral(["<li class='tocline'>", "</li>"]);

    _templateObject4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3() {
    const data = _taggedTemplateLiteral(["<a href=\"", "\" class=\"tocxref\"/>"]);

    _templateObject3 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["<bdi class='secno'>", " </bdi>"]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["<ol class='toc'>"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const lowerHeaderTags = ["h2", "h3", "h4", "h5", "h6"];
  const headerTags = ["h1", ...lowerHeaderTags];
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const name = "core/structure";
  _exports.name = name;
  const localizationStrings = {
    en: {
      toc: "Table of Contents"
    },
    nl: {
      toc: "Inhoudsopgave"
    },
    es: {
      toc: "Tabla de Contenidos"
    }
  };
  const lang = _l10n.lang in localizationStrings ? _l10n.lang : "en";
  const l10n = localizationStrings[lang];
  /**
   * @typedef {object} SectionInfo
   * @property {string} secno
   * @property {string} title
   *
   * Scans sections and generate ordered list element + ID-to-anchor-content dictionary.
   * @param {Section[]} sections the target element to find child sections
   * @param {number} maxTocLevel
   */

  function scanSections(sections, maxTocLevel, {
    prefix = ""
  } = {}) {
    let appendixMode = false;
    let lastNonAppendix = 0;
    let index = 1;

    if (prefix.length && !prefix.endsWith(".")) {
      prefix += ".";
    }

    if (sections.length === 0) {
      return null;
    }
    /** @type {HTMLElement} */


    const ol = (0, _hyperhtml.default)(_templateObject());

    for (const section of sections) {
      if (section.isAppendix && !prefix && !appendixMode) {
        lastNonAppendix = index;
        appendixMode = true;
      }

      let secno = section.isIntro ? "" : appendixMode ? alphabet.charAt(index - lastNonAppendix) : prefix + index;
      const level = Math.ceil(secno.length / 2);

      if (level === 1) {
        secno += "."; // if this is a top level item, insert
        // an OddPage comment so html2ps will correctly
        // paginate the output

        section.header.before(document.createComment("OddPage"));
      }

      if (!section.isIntro) {
        index += 1;
        section.header.prepend((0, _hyperhtml.default)(_templateObject2(), secno));
      }

      if (level <= maxTocLevel) {
        const item = createTocListItem(section.header, section.element.id);
        const sub = scanSections(section.subsections, maxTocLevel, {
          prefix: secno
        });

        if (sub) {
          item.append(sub);
        }

        ol.append(item);
      }
    }

    return ol;
  }
  /**
   * @typedef {object} Section
   * @property {Element} element
   * @property {Element} header
   * @property {string} title
   * @property {boolean} isIntro
   * @property {boolean} isAppendix
   * @property {Section[]} subsections
   *
   * @param {Element} parent
   */


  function getSectionTree(parent, {
    tocIntroductory = false
  } = {}) {
    const sectionElements = (0, _utils.children)(parent, tocIntroductory ? "section" : "section:not(.introductory)");
    /** @type {Section[]} */

    const sections = [];

    for (const section of sectionElements) {
      const noToc = section.classList.contains("notoc");

      if (!section.children.length || noToc) {
        continue;
      }

      const header = section.children[0];

      if (!lowerHeaderTags.includes(header.localName)) {
        continue;
      }

      const title = header.textContent;
      (0, _utils.addId)(section, null, title);
      sections.push({
        element: section,
        header,
        title,
        isIntro: section.classList.contains("introductory"),
        isAppendix: section.classList.contains("appendix"),
        subsections: getSectionTree(section, {
          tocIntroductory
        })
      });
    }

    return sections;
  }
  /**
   * @param {Element} header
   * @param {string} id
   */


  function createTocListItem(header, id) {
    const anchor = (0, _hyperhtml.default)(_templateObject3(), "#".concat(id));
    anchor.append(...header.cloneNode(true).childNodes);
    filterHeader(anchor);
    return (0, _hyperhtml.default)(_templateObject4(), anchor);
  }
  /**
   * Replaces any child <a> and <dfn> with <span>.
   * @param {HTMLElement} h
   */


  function filterHeader(h) {
    h.querySelectorAll("a").forEach(anchor => {
      const span = (0, _utils.renameElement)(anchor, "span");
      span.className = "formerLink";
      span.removeAttribute("href");
    });
    h.querySelectorAll("dfn").forEach(dfn => {
      const span = (0, _utils.renameElement)(dfn, "span");
      span.removeAttribute("id");
    });
  }

  function run(conf) {
    if ("tocIntroductory" in conf === false) {
      conf.tocIntroductory = false;
    }

    if ("maxTocLevel" in conf === false) {
      conf.maxTocLevel = Infinity;
    }

    renameSectionHeaders(); // makeTOC

    if (!conf.noTOC) {
      const sectionTree = getSectionTree(document.body, {
        tocIntroductory: conf.tocIntroductory
      });
      const result = scanSections(sectionTree, conf.maxTocLevel);

      if (result) {
        createTableOfContents(result);
      }
    }
  }

  function renameSectionHeaders() {
    const headers = getNonintroductorySectionHeaders();

    if (!headers.length) {
      return;
    }

    headers.forEach(header => {
      const depth = Math.min((0, _utils.parents)(header, "section").length + 1, 6);
      const h = "h".concat(depth);

      if (header.localName !== h) {
        (0, _utils.renameElement)(header, h);
      }
    });
  }

  function getNonintroductorySectionHeaders() {
    const headerSelector = headerTags.map(h => "section:not(.introductory) ".concat(h, ":first-child")).join(",");
    return [...document.querySelectorAll(headerSelector)].filter(elem => !elem.closest("section.introductory"));
  }
  /**
   * @param {HTMLElement} ol
   */


  function createTableOfContents(ol) {
    if (!ol) {
      return;
    }

    const nav = (0, _hyperhtml.default)(_templateObject5());
    const h2 = (0, _hyperhtml.default)(_templateObject6(), l10n.toc);
    (0, _utils.addId)(h2);
    nav.append(h2, ol);
    const ref = document.getElementById("toc") || document.getElementById("sotd") || document.getElementById("abstract");

    if (ref) {
      if (ref.id === "toc") {
        ref.replaceWith(nav);
      } else {
        ref.after(nav);
      }
    }

    const link = (0, _hyperhtml.default)(_templateObject7());
    document.body.append(link);
  }
});
//# sourceMappingURL=structure.js.map